export const reservation: any = {
  lineLoginBlockTitle: "LINEでログインがおすすめ！",
  lineLoginMerit01: "チャットに予約情報が届きます",
  lineLoginMerit02: "チャットでコンシェルジュに相談できます",
};
